<div *ngFor="let i of skeletons; index as index" class="d-flex justify-space-between" [class.mt-20]="index" [class.animated]="shouldShowAnimation">
  <div *ngIf="avatar.show" class="avatar-wrapper" [class.order-2]="avatar.position === position.right">
    <span *ngIf="!avatar.srcTemplate" class="avatar d-inline-block bg-grey-5"
      [ngClass]="avatar.shape === shape.circle ? 'border-radius-circle': 'border-radius-4'"></span>
    <ng-container *ngIf="avatar.srcTemplate" [ngTemplateOutlet]="avatar.srcTemplate">
    </ng-container>
  </div>

  <div class="content-wrapper" [ngClass]="{'ml-15': avatar.show && (avatar.position === position.left),
    'mr-15': avatar.show && (avatar.position === position.right)}">
    <h3 *ngIf="title.show" class="title" [class.outline]="this.title?.outline"></h3>
    <ul *ngIf="list.show" class="paragraph-list list-style-none" [style.width]="textContentWidth">
      <li *ngFor="let row of paragraphs" class="list-item"></li>
    </ul>
  </div>
</div>
